import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormInputPassword,
  title: 'Password',
  category: ComponentCategory.FormControls,
};
